import React, { useEffect, useRef, useState, FC } from 'react';
import { googleClickDropdownEvent } from '../../../utils/analytics';
import { documentService } from '../../../utils/window.utils';
import Icon from '../../@shared/icon';
import { TSecondFilterProps } from '../types/seriesListing.types';

const SecondFilter: FC<TSecondFilterProps> = (props) => {
  const dropdownTypeRef = useRef(null);
  const dropdownTypeInputRef = useRef(null);
  const [secondFilterData, setSecondFilterData] = useState<string[]>([]);

  const {
    showPopup,
    setShowPopup,
    dropdownTypeText,
    showDropdownType,
    setShowDropdownType,
    applyFilter,
    handleClickOutside,
    isMobile,
    iconType,
    ALLTYPES,
    OTHER,
    series,
  } = props;

  useEffect(() => {
    const typesFilteredArr = (): string[] => {
      const typeArr = [ALLTYPES];
      series?.filter((tractor) => tractor.type && tractor.type !== '').map((tractor) => typeArr.push(tractor.type));
      typeArr.push(OTHER);
      return typeArr.filter(function (v, i, a) {
        return i === a.indexOf(v);
      });
    };
    setSecondFilterData(typesFilteredArr);
  }, [ALLTYPES, series]);

  useEffect(() => {
    const mouseDownHandler = (event) => handleClickOutside(event, dropdownTypeRef, dropdownTypeInputRef, setShowDropdownType);

    if (documentService()) {
      documentService().addEventListener('mousedown', mouseDownHandler);
    }
    return () => {
      documentService()?.removeEventListener('mousedown', mouseDownHandler);
    };
  }, [dropdownTypeRef]);

  return (
    <li key={dropdownTypeText} className={`product-card-filters__block ${showDropdownType ? 'product-card-filters__block--mobile' : null}`}>
      <div
        className="product-card-filters__block-item"
        onClick={() => {
          setShowDropdownType(!showDropdownType);
          isMobile && setShowPopup(!showPopup);
        }}
        ref={dropdownTypeInputRef}
      >
        {showDropdownType && <span></span>}
        <span className={'product-card-filters__block-item-text'}>{dropdownTypeText}</span>
        <Icon iconName={showDropdownType ? iconType : 'arrow-chevron-down'} size={24} />
      </div>
      {showDropdownType && (
        <ul
          className={`product-card-filters__dropdown-wrapper ${showDropdownType ? 'product-card-filters__dropdown-wrapper--mobile' : null}`}
          ref={dropdownTypeRef}
        >
          {secondFilterData.map((tractor, secondFilterIndex) => (
            <li key={tractor} className="product-card-filters__dropdown-element">
              <span
                className={'product-card-filters__dropdown-element-link'}
                onClick={() => {
                  applyFilter(tractor);
                  isMobile && setShowPopup(!showPopup);
                  googleClickDropdownEvent(dropdownTypeText, tractor, secondFilterIndex + 1);
                }}
              >
                {tractor}
              </span>
            </li>
          ))}
        </ul>
      )}
    </li>
  );
};

export default SecondFilter;
